const contactAttribution =
  '<a href="https://laioutdigitalbyra.se/kontakt/" target="_blank" rel="noopener noreferrer">Kontakta Laiout Digitalbyrå</a>';

export function configureMapAttribution(map) {
  map.attributionControl?.setPrefix(contactAttribution);
}
